import { render, staticRenderFns } from "./ShowItem.vue?vue&type=template&id=3c60586b&scoped=true&"
import script from "./ShowItem.vue?vue&type=script&lang=js&"
export * from "./ShowItem.vue?vue&type=script&lang=js&"
import style0 from "./ShowItem.vue?vue&type=style&index=0&id=3c60586b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c60586b",
  null
  
)

export default component.exports